import { render, staticRenderFns } from "./FormPrint.vue?vue&type=template&id=2b20b7aa&scoped=true"
import script from "./FormPrint.vue?vue&type=script&lang=js"
export * from "./FormPrint.vue?vue&type=script&lang=js"
import style0 from "./FormPrint.vue?vue&type=style&index=0&id=2b20b7aa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b20b7aa",
  null
  
)

export default component.exports